module.exports = __webpack_public_path__ + "static/img/GB.69cb8483.svg";